// Location behavior for grid columns.
//
// Provides a searchable dropdown cell editor for lot locations,
// reusing the same /api/locations endpoint as the SearchableSelectComponent.
//
// Column def:   { field: "location", behavior: "location" }
// Config:       data-grid-behaviors-value='{"location":{"url":"/api/locations","storageKey":"locations","valueField":"locationId","forms":[...]}}'
//
// The cell displays the location code (label). The selected location ID is
// stored in row data under the `locationId` field so it can be sent on save.

import { createBehavior } from "./create_behavior"
import { SearchableCellEditor } from "./searchable_cell_editor"

export const location = createBehavior({
  cellEditor: SearchableCellEditor,
  cellEditorPopup: true,

  cellEditorParams(config) {
    return {
      url: config.url || "/api/locations",
      storageKey: config.storageKey || "locations",
      valueField: config.valueField || "locationId",
      forms: config.forms || []
    }
  }
})
